import PictureResult from "./PictureResult";
import TaskResult from "./TaskResult";
import Element from "@/model/Elements/Element";

export default class OilResult extends TaskResult {
  cleaned: boolean | null;
  element: Element | null;
  oil_changed: boolean | null;
  oil_filtered: boolean | null;
  filter_changed: boolean | null;
  polarity: number | null;
  temperature: number | null;
  pictures: PictureResult[];

  constructor(
    cleaned: boolean | null,
    element: Element | null,
    oil_changed: boolean | null,
    oil_filtered: boolean | null,
    filter_changed: boolean | null,
    polarity: number | null,
    temperature: number | null,
    pictures: PictureResult[]
  ) {
    super(null, null, null);
    this.cleaned = cleaned;
    this.element = element;
    this.oil_changed = oil_changed;
    this.oil_filtered = oil_filtered;
    this.filter_changed = filter_changed;
    this.polarity = polarity;
    this.temperature = temperature;
    this.pictures = pictures;
  }
}
